module.exports = __webpack_public_path__ + "static/media/korapay.9342ab75.png";